import { useGetUrl } from '@seek/ca-myprofile-utils';
import { useTranslations } from '@vocab/react';
import { Text } from 'braid-design-system';
import React from 'react';

import { ExternalLink } from 'src/components/ExternalLink/ExternalLink';
import { useAppConfig } from 'src/modules/appConfig';

import translations from './.vocab';

export const StandardProfileVisibilityMessage = () => {
  const { t } = useTranslations(translations);
  const { brand, zone, language, isUnifiedSite } = useAppConfig();

  const getUrl = useGetUrl(zone, language, isUnifiedSite);

  return (
    <Text>
      {t('Your default resumé can be...', {
        brand,
        span: (v) => <span data-automation="resume-standard-message">{v}</span>,
        ExternalLinkProfilePrivacy: (v) => (
          <ExternalLink
            target="_blank"
            rel="noopener noreferrer"
            href={getUrl('profile-privacy')}
            weight="weak"
            hitArea="large"
          >
            {v}
          </ExternalLink>
        ),
      })}
    </Text>
  );
};
